import { LoyaltyTierBadge } from "@/api/orval/model";

/** The API sends the badge as a number; the names mirror `LoyaltyService.Contract/Enums`. */
export const TierBadge = {
  /** No emblem: a plain cut shape in the tier colour. */
  Color: LoyaltyTierBadge.NUMBER_0,
  /** The tier name's first letter, engraved on an award seal. */
  Initial: LoyaltyTierBadge.NUMBER_1,
  Star: LoyaltyTierBadge.NUMBER_2,
  Gem: LoyaltyTierBadge.NUMBER_3,
  Crown: LoyaltyTierBadge.NUMBER_4,
  Heart: LoyaltyTierBadge.NUMBER_5,
  Trophy: LoyaltyTierBadge.NUMBER_6,
  Medal: LoyaltyTierBadge.NUMBER_7,
  Rosette: LoyaltyTierBadge.NUMBER_8,
  Laurel: LoyaltyTierBadge.NUMBER_9,
  Shield: LoyaltyTierBadge.NUMBER_10,
  Diamond: LoyaltyTierBadge.NUMBER_11,
  Pearl: LoyaltyTierBadge.NUMBER_12,
  Lotus: LoyaltyTierBadge.NUMBER_13,
  Sparkle: LoyaltyTierBadge.NUMBER_14,
  Droplet: LoyaltyTierBadge.NUMBER_15,
  Feather: LoyaltyTierBadge.NUMBER_16,
  Moon: LoyaltyTierBadge.NUMBER_17,
  Sun: LoyaltyTierBadge.NUMBER_18,
} as const;
